module.exports = __webpack_public_path__ + "img/portfolio1.25c17ebf.webp";